<template>
    <div class="col-xs-12" :class="specialTitle ?  'col-md-4' : 'col-md'">
        <div class="card-lead-column">
            <span class="lead-card-item-client-name" v-if="specialTitle">
                <strong class="first-name">{{ titles.first_name }}</strong>
                <span>{{ titles.last_name }}</span>
            </span>
            <template v-else>
                <strong v-html="title" v-if="title"></strong>
                <div>
                    <slot></slot>
                </div>
            </template>
        </div>
    </div>
</template>


<script>
    export default {
        name: "lead-card-item",
        props: {
            title: String,
            specialTitle: {
                default: false,
                type: Boolean,
            }
        },
        computed: {

            titles() {

                const names      = this.title.split(" ");
                const first_name = names.shift();

                return {
                    first_name,
                    last_name: names.join(' ')
                };
            }
        }
    }
</script>

<style lang="scss">
.lead-card-item-client-name {
    color: #222;
    text-transform: uppercase;
    word-break: break-all;

    .first-name {
        font-size: 24px;
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/LeadCardItem.vue